import { IBackgroundOperation } from "containers/background-operations/types";
import { BACKGROUND_OPERATION_STATUS } from "containers/background-operations/types";

export interface IBackgroundOperationsState {
  backgroundOperations: IBackgroundOperation[];
  totalCount: number;
  startedOperationIds: string[];
  statusByOperationId: Record<string, BACKGROUND_OPERATION_STATUS>;
  cancellingOperationIds: string[];
  isFetchingAll: boolean;
}

export const backgroundOperationsInitialState: IBackgroundOperationsState = {
  backgroundOperations: [],
  totalCount: 0,
  startedOperationIds: [],
  statusByOperationId: {},
  cancellingOperationIds: [],
  isFetchingAll: false,
};
